import { cn } from '@/lib/utils';

interface LoadingStateProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  message?: string;
  className?: string;
}

export function LoadingState({
  size = 'md',
  fullScreen = false,
  message = 'Chargement...',
  className,
}: LoadingStateProps) {
  if (fullScreen) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <div className="animate-pulse flex flex-col items-center">
          <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center mb-4">
            <div className="w-8 h-8 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
          </div>
          <p className="text-gray-600 font-medium">{message}</p>
        </div>
      </div>
    );
  }

  // Skeleton loader variant
  const skeletonCount = {
    sm: 3,
    md: 5,
    lg: 7,
  };

  return (
    <div className={cn('space-y-4', className)}>
      {Array.from({ length: skeletonCount[size] }).map((_, index) => (
        <div
          key={index}
          className={cn(
            'bg-gray-200 rounded-lg animate-pulse',
            size === 'sm' && 'h-12',
            size === 'md' && 'h-20',
            size === 'lg' && 'h-24',
            index === 0 && 'rounded-xl'
          )}
        />
      ))}
    </div>
  );
}